import { Model } from '@vuex-orm/core'
import Channels from 'src/api/channels.js'
import constants from 'src/config/constants.ts'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export class Survey extends Model {
  static entity = 'surveys'

  static fields () {
    return {
      id: this.uid(),
      uuid: this.string(''),
      questions: this.attr([
        {
          question: '',
          options: [],
          order: 0,
          has_user_option: false,
          type: constants.survey.question_type.SINGLE_CHOICE,
          key: GlobalPrototypes.uuid()
        }
      ]),
      results_visibility: this.string(constants.survey.resultsVisibility.NONE),
      is_anonymous: this.boolean(false),
      has_translations: this.boolean(false),
      expires_at: this.string(null),
      channels: this.attr([])
    }
  }

  static async endVoting (surveyId) {
    return Channels.putChannelEndSurveyById(surveyId)
  }

  static async vote (surveyUuid, data) {
    return Channels.putChannelVoteSurveyById(surveyUuid, data)
  }

  static async revoke (surveyUuid) {
    return Channels.deleteChannelVoteSurveyById(surveyUuid)
  }

  static async getDetails (surveyUuid) {
    return Channels.getChannelSurveyById(surveyUuid)
  }
}

export default Survey
